import * as React from 'react'
import { useAuth } from '@workos-inc/authkit-react'
import { Link } from 'react-router-dom'
import { motion, AnimatePresence } from '@/components/framer-motion'

import { NavMain } from '@/components/navigation/NavMain'
import { NavUser } from '@/components/navigation/NavUser'
import { SidebarTeam } from '@/components/layout/SidebarTeam'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from '@/components/ui/sidebar'
import clsx from 'clsx'

function SidebarLogo() {
  const { state } = useSidebar()
  const isCollapsed = state === 'collapsed'

  return (
    <div
      className={clsx(
        'flex py-2 overflow-hidden',
        isCollapsed && 'self-center',
        !isCollapsed && 'self-start pl-4',
      )}
    >
      <Link
        to="/"
        className="flex items-center justify-center relative w-20 h-8"
      >
        <AnimatePresence mode="wait">
          {!isCollapsed ? (
            <motion.div
              key="logo"
              initial={{ opacity: 0, scale: 0.9, x: -10 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              exit={{ opacity: 0, scale: 0.9, x: -10 }}
              transition={{ duration: 0.25, ease: 'easeInOut' }}
              className="absolute inset-0"
            >
              <img
                src="/assets/images/super-logo.svg"
                alt="Super Logo"
                width={80}
                height={32}
                className="w-full h-full object-contain"
              />
            </motion.div>
          ) : (
            <motion.div
              key="lettermark"
              initial={{ opacity: 0, scale: 1.2, x: -20 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              exit={{ opacity: 0, scale: 1.2, x: -30 }}
              transition={{ duration: 0.15, ease: 'easeOut' }}
              className="absolute left-6"
            >
              <img
                src="/assets/images/super-lettermark.svg"
                alt="Super Logo"
                width={32}
                height={32}
                className="w-8 h-8 object-contain"
              />
            </motion.div>
          )}
        </AnimatePresence>
      </Link>
    </div>
  )
}

export function AppSidebar({
  collapsible,
  variant,
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const { user } = useAuth()

  return (
    <Sidebar variant={variant} collapsible={collapsible} {...props}>
      <SidebarHeader>
        <SidebarLogo />
        <SidebarTeam />
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
      </SidebarContent>
      <SidebarFooter>{user && <NavUser user={user} />}</SidebarFooter>
    </Sidebar>
  )
}
